export const userDTO = data => {
    return {
        ID: {
            default: data.ID,
            hidden: true,
        },
        deleted: {
            default: data.deleted,
            hidden: true,
        },
        email: {
            label: "email",
            default: data.email,
            email: data.email,
            rule: ['required', 'email'],
        },
        name: {
            label: "name",
            default: data.name,
            name: data.name,
            rule: ['required'],
        },
        phone: {
            label: "phone",
            default: data.phone || '',
            phone: data.phone || '',
            type: 'phone'
        },
        scopes: {
            label: "scopes",
            default: data.scopes,
            scopes: data.scopes,
            rule: ['required'],
        },
        shops: {
            label: "shops",
            default: data.shops,
            shops: data.shops,
            rule: ['required'],
        },
    }
}